import MUIAvatar, { AvatarProps as MUIAvatarProps } from '@mui/material/Avatar';

export interface AvatarProps extends MUIAvatarProps {}

export const Avatar = MUIAvatar;
